import React from 'react';
import { Link } from 'react-router-dom';

import SurveyService from '../services/SurveyService';
import { sortByJob } from '../common/Utilities';
import SurveyList from "./SurveyList";
//import { correlatorUser } from '../common/Utilities';

import '../App.css';

class SurveyStart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      editType: '',
      surveys: [],
      selectedSurvey: {}
    };

    this.loadSurveys = () => {
      const db = new SurveyService();
      db.list().then(surveys => {
        this.setState({ surveys: surveys.sort(sortByJob) });
      });
    };

    this.selectSurvey = (job, client) => {
      if (this.state.selectedSurvey.job && (this.state.selectedSurvey.job === job && this.state.selectedSurvey.client === client)) {
          this.setState({ selectedSurvey: { job: "", client: ""}});
      } else {
        this.setState({ selectedSurvey: { job: job, client: client}});    
      }
    }
    
    // Navigate is for the double click - navigate directly to the page
    this.selectSurveySave = (job, client) => {
      if (this.state.selectedSurvey.job && (this.state.selectedSurvey.job === job && this.state.selectedSurvey.client === client)) {
        this.setState({ selectedSurvey: { job: "", client: ""}});
      } else {
        this.setState({ selectedSurvey: { job: job, client: client}},
          () => this.props.history.push(this.linkAddress()));
        ;
      }
    };


    // Set the link address to either editing an existing url or starting a new survey
    // if the edit option has been selected and a job hasn't been chosen yet set the link
    // to #
    this.linkAddress = () =>
      this.state.editType === "edit" ? "/survey/edit" : 
      (!(!this.state.selectedSurvey.job || this.state.selectedSurvey.job.length===0) ? `/survey/edit/${this.state.selectedSurvey.job}/${this.state.selectedSurvey.client}` : "#");
    }

  render() {
    return (
      <div className="container-fluid">
        <h1 className="heading">Home</h1>
        <div className="row">
          <div className="col-md-2">
                    <div className="radio">
                        <label><input type="radio" name="optEditType" onClick={() => {this.setState({ editType: 'edit'})}} />Start a New Survey</label>
            </div>
            <div className="radio">
              <label><input type="radio" name="optEditType" onClick={() => { this.loadSurveys(); this.setState({ editType: 'select'})}} />Edit an Existing Survey</label>
            </div>
          </div>
        </div>
        <div className="row" style={{display: this.state.editType==="select" ? "block" : "none"}}>
          <SurveyList surveys={this.state.surveys} onSelect={this.selectSurvey}  onSelectSave={this.selectSurveySave} />
        </div>
            <div className="buttonRow">
                <div>
                    <button style={{ 'fontSize': '12px', 'color':'#676767' }} className="btn btn-default">Cancel</button>
          </div>
          <div>
                    <Link to={this.linkAddress()} style={{ 'fontSize': '12px', 'color': '#676767', 'width':'68px'}}
              onClick={e => {
                  if (this.linkAddress === "#") {
                    e.preventDefault()
                  }
                }
              }
              disabled={this.state.editType === "" || (this.state.editType === "select" && 
              (!this.state.selectedSurvey.job || this.state.selectedSurvey.job.length===0))} className="btn btn-default">Next &raquo;
            </Link>
          </div>
        </div>
      </div>
  )}
};

export default SurveyStart;
